import React, {useState, useEffect} from 'react';
import './responsive.css';
import './team.css';
import { Image, Button } from 'react-bootstrap';

const kieranpic = require('../assets/images/kieranpic.png');
const justinpic = require('../assets/images/justinpic.PNG');
const vaishnavipic = require('../assets/images/vaishnavipic.png');

const Team = () => {
    return (
        <div className='team-Wrapper'>
            <h1 className='team-header'>
                Meet The Team
            </h1>

            <div className='team-Founders'>
                <div className='VaishPic'>
                    <Image src={vaishnavipic}/>
                    <h1 className='team-Founders-Descr'>
                        Vaish Sagar
                    </h1>

                </div>
                <div className='VaishPic'>
                    <Image src={kieranpic}/>
                    <h1 className='team-Founders-Descr'>
                        Kieran Moore
                    </h1>

                </div>
                <div className='VaishPic'>
                    <Image src={justinpic}/>
                    <h1 className='team-Founders-Descr'>
                        Justin Mccollor
                    </h1>

                </div>

                

            </div>

            <div className='team-Members'>

                <h1 className='team-Members-Descr'>
                    
                </h1>
            
            </div>

        </div>

    );

};

export default Team;